import React, { useState } from "react";
import flogo from "../assets/images/Grayzo_New_Logo_White1.webp";
import { Modal } from "react-bootstrap";
import { FaWhatsapp, FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn, FaYoutube } from "react-icons/fa";

// animation
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
// import { Link } from "react-router-dom";

// animation

// Add a scrollToTop handler
// const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

function Footer() {
  const [showPrivacyModelPopup, setshowPrivacyModelPopup] = useState(false);
  const [showTeamsModelPopup, setshowTeamsModelPopup] = useState(false);
  // animation
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const iconStyle = {
    position: 'fixed',
    bottom: 50,
    right: 30,
    backgroundColor: 'green',
    width: 50,
    height: 50,
    textAlign: 'center',
    lineHeight: '40px',
    fontSize: 25,
    zIndex: 1,
  }

  // animation
  return (
    <>
      <a
        className="btn btn-lg btn-lg-square me-2"
        style={iconStyle}
        href="https://api.whatsapp.com/send?phone=+919958222011&text=Hi, I contacted through your website."
        rel="noreferrer"
        title="whatsapp"
        target="_blank">
        <FaWhatsapp style={{ color: 'white' }} size={24} />
      </a>
      <div className="footer_main">
        <div className="container-fluid text-light mt-5 footer_top pb-5">
          <div className="container pt-5">
            <div className="row g-5">
              <div className="col-lg-4 section1 col-md-6">
                <h3
                  className="text-white fw-600 fs-19em"
                  data-aos="fade-up"
                  data-aos-once="true"
                  data-aos-delay="100"
                >
                  GRAYZO INDIA PVT. LTD.
                </h3>
                <div className="d-flex flex-column justify-content-start text-black">
                  <p
                    style={{
                      color: "white",
                      fontWeight: "400",
                      fontStyle: "normal",
                      fontSize: "16px",
                    }}
                    data-aos="fade-up"
                    data-aos-once="true"
                    data-aos-delay="200"
                  >
                    Unit No. <span className="num-font">713</span>, <span className="num-font">7th</span> floor, Spaze Boulevard-<span className="num-font">1</span>, Sector-<span className="num-font">47</span>, Gurugram, Haryana-<span className="num-font">122002</span>
                  </p>
                  <p className="text-white">
                    <span className="me-2">
                      <i className="bi bi-envelope-open me-1"></i>
                      info@grayzo.in
                    </span>
                    <span className="num-font">
                        <i className="bi bi-telephone me-2"></i>
                        9958222011, 8447000912
                      </span>
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 section2 offset-0 offset-lg-5 text-start text-md-end">
                <a href="/" className="ms-lg-5">
                  <img
                    src={flogo}
                    width={150}
                    height={63}
                    className="img-fluid"
                    style={{ maxWidth: "150px", height: "auto", display: "block" }}
                    alt="company logo"
                    loading="lazy"
                    decoding="async"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid footer_bottom text-light py-4 cust_ft">
          <div className="container">
            <div className="row">
              <div className="col-md-9" >
                <p
                  className="mb-md-0 text-white fw-500"
                >
                  <span className="num-font">2025</span> all &copy; Reserved in Grayzo Door & Partition Systems
                </p>
              </div>
              <div className="col-md-3 text-end">
                <a
                  href="#"
                  className="text-white text-decoration-none me-4"
                  onClick={(e) => { e.preventDefault(); setshowPrivacyModelPopup(true) }}
                >
                  Privacy Policy
                </a>
                <a
                  href="#"
                  className="text-white text-decoration-none"
                  onClick={(e) => { e.preventDefault(); setshowTeamsModelPopup(true) }}
                >
                  Teams of Use
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="footer_main">
        <div className="container-fluid text-light mt-5 footer_top pb-5">
          <div className="container pt-5">
            <div className="row g-5">
              <div className="col-lg-3 col-md-6">
                <h3
                  className="text-white mb-4 fw-600 fs-18em"
                  data-aos="fade-up"
                  data-aos-once="true"
                  data-aos-delay="100"
                >
                  About Us
                </h3>
                <div className="d-flex flex-column justify-content-start text-black">
                  <p
                    style={{
                      color: "white",
                      fontFamily: '"Rampart One", sans-serif',
                      fontWeight: "400",
                      fontStyle: "normal",
                      fontSize: "16px",
                    }}
                    data-aos="fade-up"
                    data-aos-once="true"
                    data-aos-delay="200"
                  >
                    Welcome to Grayzo Door & Partition System, your go-to for
                    high-end PVD partitions. Since <span className="num-font">2015</span>, we've delivered
                    excellence through custom door and partition solutions for
                    both commercial and residential spaces. We prioritize
                    quality, durability, and customer satisfaction, ensuring
                    seamless experiences from consultation to installation.
                    Discover the Grayzo difference today and elevate your space
                    with our exceptional craftsmanship.
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <h3
                  className="text-white mb-4 fw-600 fs-18em"
                  data-aos="fade-up"
                  data-aos-once="true"
                  data-aos-delay="100"
                >
                  Usefull Links
                </h3>
                <div
                  className="d-flex flex-column justify-content-start footer_links"
                  data-aos="fade-up"
                  data-aos-once="true"
                  data-aos-delay="200"
                >
                  <Link
                    className="text-white mb-2 text-decoration-none"
                    to="/"
                    onClick={scrollToTop}
                  >
                    <i className="bi bi-arrow-right text-white me-2"></i>Home
                  </Link>
                  <Link
                    className="text-white mb-2 text-decoration-none"
                    to="/our-story"
                    onClick={scrollToTop}
                  >
                    <i className="bi bi-arrow-right text-white me-2"></i>Company
                  </Link>
                  <Link
                    className="text-white mb-2 text-decoration-none"
                    to="/swing-door"
                    onClick={scrollToTop}
                  >
                    <i className="bi bi-arrow-right text-white me-2"></i>
                    Products
                  </Link>
                  <Link
                    className="text-white mb-2 text-decoration-none"
                    to="/glass"
                    onClick={scrollToTop}
                  >
                    <i className="bi bi-arrow-right text-white me-2"></i>Glass
                  </Link>
                  <Link
                    className="text-white mb-2 text-decoration-none"
                    to="/our-clients"
                    onClick={scrollToTop}
                  >
                    <i className="bi bi-arrow-right text-white me-2"></i>Our
                    Clients
                  </Link>
                  <Link
                    className="text-white text-decoration-none"
                    to="/contact-us"
                    onClick={scrollToTop}
                  >
                    <i className="bi bi-arrow-right text-white me-2"></i>Contact
                    Us
                  </Link>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <h3
                  className="text-white mb-4 fw-600 fs-18em"
                  data-aos="fade-up"
                  data-aos-once="true"
                  data-aos-delay="100"
                >
                  Contact Us
                </h3>
                <h5
                  className="text-white mb-4 fw-600 fs-18em"
                  data-aos="fade-up"
                  data-aos-once="true"
                  data-aos-delay="200"
                >
                  Corporate Office
                </h5>
                <div
                  data-aos="fade-up"
                  data-aos-once="true"
                  data-aos-delay="300"
                >
                  <p className="mb-2 text-white">
                    Unit No.<span className="num-font">713</span>, <span className="num-font">7th</span> floor, Spaze Boulevard-<span className="num-font">1</span>, Sector-<span className="num-font">47</span>, Gurugram, Haryana-<span className="num-font">122002</span>
                  </p>
                  <p className="mb-2 text-white">
                    <i className="bi bi-envelope-open text-white me-1"></i>
                    info@grayzo.in
                  </p>
                  <p className="mb-2 text-white">
                    <i className="bi bi-globe2 text-white me-1"></i>
                    www.grayzo.in
                  </p>
                  <p className="mb-0 text-white">
                    <i className="bi bi-telephone text-white me-2"></i>
                    9958222011, 8447000912
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <h3
                  className="text-white mb-4 fw-600 fs-18em"
                  data-aos="fade-up"
                  data-aos-once="true"
                  data-aos-delay="100"
                >
                  Follow Us
                </h3>
                <div
                  className="d-flex nav-contact mb-3"
                  style={{ backgroundColor: "gray" }}
                  data-aos="fade-up"
                  data-aos-once="true"
                  data-aos-delay="200"
                >
                  <a
                    className="me-2 border-none"
                    href="https://www.facebook.com/profile.php?id=100091982918966"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaFacebookF style={{ color: "blue" }} size={18} />
                  </a>
                  <a
                    className="me-2 border-none"
                    href="https://www.instagram.com/grayzo_official/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaInstagram style={{ color: "#d250db" }} size={18} />
                  </a>
                  <a
                    className="me-2 border-none"
                    href="https://twitter.com/Grayzo_official"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaTwitter style={{ color: "#59baff" }} size={18} />
                  </a>
                  <a
                    className="me-2 border-none"
                    href="https://www.linkedin.com/company/grayzo-glass/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaLinkedinIn style={{ color: "#729eff" }} size={18} />
                  </a>
                  <a
                    className="me-2 border-none"
                    href="https://www.youtube.com/channel/UCvF4eJdUJuijRK138AwLAOg"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaYoutube style={{ color: "red" }} size={18} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid footer_bottom text-light py-4 cust_ft ">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center" >
                <p
                  className="mb-md-0 text-white fs-20px fw-500" 
                >
                  2025 all &copy; Reserved in Grayzo Door & Partition Systems
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <Modal
        className="privacy_policy_popup"
        show={showPrivacyModelPopup}
        onHide={() => setshowPrivacyModelPopup(false)}
        backdrop={true}
        size="lg"
        centered
      >
        <Modal.Body className="custom_popup">
          <button
            type="button"
            className="btn-close position-absolute end-0 top-0 m-3"
            aria-label="Close"
            onClick={() => setshowPrivacyModelPopup(false)}
          ></button>

          <div className="custom_popup_body">
  <div className="mt-4">
    <h5 className="dark_color fw-bold">
      Privacy Policy
    </h5>

    <div className="text-justify">
      <h6 className="fw-bold">Privacy Policy for Grayzo</h6>
      <p>
        At Grayzo, your privacy is important to us. This privacy policy explains our policy regarding the way we treat information when you visit our site.
      </p>

      <h6 className="fw-bold">Information we collect:</h6>
      <p>
        Personal information may include your name, email address or other information conveyed to us via forms or account registration.
      </p>

      <h6 className="fw-bold">How we use your information</h6>
      <p>We use your information to:</p>

      <ul>
        <li>Provide and improve our services</li>
        <li>Respond to your inquiries</li>
        <li>Send you updates or promotional material (if you consent)</li>
      </ul>

      <h6 className="fw-bold">Data Protection</h6>
      <p>
        We use reasonable measures to safeguard your data. But no method of transmission over the internet is 100% secure.
      </p>
    </div>
  </div>
</div>

        </Modal.Body>
      </Modal>
      <Modal
        className="team_and_condition_popup"
        show={showTeamsModelPopup}
        onHide={() => setshowTeamsModelPopup(false)}
        backdrop={true}
        size="lg"
        centered
      >
        <Modal.Body className="custom_popup">
          <button
            type="button"
            className="btn-close position-absolute end-0 top-0 m-3"
            aria-label="Close"
            onClick={() => setshowTeamsModelPopup(false)}
          ></button>

          <div className="custom_popup_body">

            <div className=" mt-4">
              <h5 className="dark_color fw-600 mb-3">
  Disclaimer
</h5>

              <div className="text-justify">
                <p>Products appearing on the Grayzo site is intended for general reference only and pertains specifically to the door and partition solutions we provide. We work to ensure that all published information reflects the latest technical and product data; nonetheless.</p>
                <p>Illustrated gateways, stated measurements, and stated attributes are subject to modification to accommodate the latest manufacturing techniques or to suit specific site conditions; such changes may occur without prior notification. We strongly recommend reviewing any proposed orders and installation plans with a Grayzo representative or a qualified installer prior to proceeding with any transaction or assembly.</p>
                <p>Grayzo shall not be liable for any loss, injury, or damage, whether direct, indirect, or consequential, that arises from the adherence to, or reliance upon, any details, product, or recommendation published on this site.</p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Footer;
